module.exports = __webpack_public_path__ + "media/images/ticket/matome_warning_l-eae7871d01ba505f20d5d68845a7efb4.png";